import { css } from 'config/emotionCss';

export const cardUploadStyle = css`
  & > .ant-upload {
    border-radius: 10px;
    background-color: #f1f6ff;

    > .ant-upload[role='button'] {
      padding: 0;
    }
  }
`;

export const galleryStyle = css`
  gap: 8px;
  display: flex;
  flex-wrap: wrap;

  > .media-item {
    margin: 0;
  }
`;
